cobalt-link {
  display: inline-flex;
}
